import React, { Component } from "react";

import { GlobalConsumer } from "../../../context/GlobalContext";

import Api from "../../../lib/componentApi";

import SubmitItemLoading from "../../Loadings/SubmitItem";

export default class UpdateItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: props.selectedItem.quantity || 0,
      selectedOptionId: "",
      selectedOptions: props.selectedItem.options,
      totalAmount: props.selectedItem.totalAmount
    };
  }

  renderItemQuantitySection = () => {
    const { quantity } = this.state;
    const { selectedItem } = this.props;
    return (
      <div className="white-bg add-item-form">
        <p>{selectedItem.description}</p>
        <div className="add-item-input">
          <button
            disabled={quantity <= 1}
            onClick={e => this.handleItemCount(e, "dec")}
          >
            -
          </button>
          <span>{quantity}</span>
          <button onClick={e => this.handleItemCount(e, "inc")}>+</button>
        </div>
      </div>
    );
  };
  handleRemoveValue = (event, optionId, optionValue) => {
    event.preventDefault();
    const { item } = this.props;
    let { selectedOptions } = this.state;
    const defaultOption = item.options.find(
      itemOption => itemOption.id === optionId
    );
    let matchingOption = this.getMatchingOption(optionId);
    const values = matchingOption.values;
    let newValues = values.map(value => {
      if (
        value.restaurantItemOptionValueId === optionValue.id &&
        value.quantity
      ) {
        value.quantity -= 1;
      }
      return value;
    });
    newValues = newValues.filter(value => value.quantity);
    matchingOption.values = newValues;
    let optionIndex = selectedOptions.findIndex(
      ({ restaurantItemOptionId }) =>
        restaurantItemOptionId === defaultOption.id
    );
    selectedOptions[optionIndex] = matchingOption;
    this.setState(
      {
        selectedOptions
      },
      () => {
        this.calculateItemsAmount(selectedOptions);
      }
    );
  };
  handleAccordionMenu = (e, id) => {
    e.preventDefault();
    const { selectedOptionId } = this.state;
    if (selectedOptionId !== id) {
      this.setState({ selectedOptionId: id });
    } else {
      this.setState({ selectedOptionId: "" });
    }
  };
  titleDescription = selectedOption => {
    if (
      !selectedOption ||
      !selectedOption.values ||
      !selectedOption.values.length
    ) {
      return "Unselected";
    }
    const totalValue = this.getAllValuesQuantity(selectedOption.values);
    if (totalValue === 1) {
      return selectedOption.values[0].name;
    } else {
      return `${totalValue} item`;
    }
  };
  getMatchingOption = optionId => {
    let { selectedOptions } = this.state;
    return selectedOptions.find(
      selectedOption => selectedOption.restaurantItemOptionId === optionId
    );
  };
  calculateItemsAmount = options => {
    let { newAmount, freebie } = this.props.item;
    const { isFreebie } = this.props;
    const { quantity } = this.state;
    let valueAmount = 0;
    options.forEach(option => {
      if (option.values && option.values.length) {
        option.values.forEach(value => {
          valueAmount += value.quantity * value.amount;
        });
      }
    });
    let totalAmount = 0;
    if (freebie && isFreebie) {
      let amount =
        parseFloat((newAmount + valueAmount) * quantity) -
        parseFloat(newAmount);
      totalAmount = amount.toFixed(2);
    } else {
      totalAmount = parseFloat((valueAmount + newAmount) * quantity).toFixed(2);
    }

    this.setState({
      totalAmount
    });
  };
  getAllValuesQuantity = values => {
    let total = 0;
    if (values.length) {
      values.forEach(value => {
        total += value.quantity;
      });
    }
    return total;
  };
  handleAddValue = (e, optionId, optionValue) => {
    e.preventDefault();
    const { item } = this.props;
    const defaultOption = item.options.find(
      itemOption => itemOption.id === optionId
    );
    let { selectedOptions } = this.state;
    const matchingOption = this.getMatchingOption(optionId);
    if (matchingOption) {
      selectedOptions.map(option => {
        if (option.restaurantItemOptionId === defaultOption.id) {
          if (defaultOption.multipleSelection === 1) {
            const value =
              option.values.find(
                value => value.restaurantItemOptionValueId === optionValue.id
              ) || {};

            option.values = [
              {
                restaurantItemOptionValueId: optionValue.id,
                quantity: value.quantity ? 0 : 1,
                amountEffectType: optionValue.amountEffectType,
                amount: optionValue.amount,
                name: optionValue.name,
                id: optionValue.id,
                quantityAble: optionValue.quantityAble
              }
            ];
          } else if (defaultOption.multipleSelection === 0) {
            if (
              option.values.filter(
                value => optionValue.id === value.restaurantItemOptionValueId
              ).length
            ) {
              option.values.map(value => {
                if (
                  value.restaurantItemOptionValueId === optionValue.id &&
                  value.quantity < value.quantityAble
                ) {
                  value.quantity += 1;
                }
              });
            } else {
              const value = {
                restaurantItemOptionValueId: optionValue.id,
                quantity: 1,
                amountEffectType: optionValue.amountEffectType,
                amount: optionValue.amount,
                name: optionValue.name,
                quantityAble: optionValue.quantityAble,
                id: optionValue.id
              };
              option.values.push(value);
            }
          } else {
            if (
              option.values.filter(
                value => optionValue.id === value.restaurantItemOptionValueId
              ).length
            ) {
              if (optionValue.quantityAble === 1) {
                option.values.map(value => {
                  if (value.restaurantItemOptionValueId === optionValue.id) {
                    if (value.quantity) {
                      value.quantity -= 1;
                    } else {
                      value.quantity += 1;
                    }
                  }
                  return value;
                });
              } else {
                option.values.map(value => {
                  if (value.restaurantItemOptionValueId === optionValue.id) {
                    if (value.quantity < value.quantityAble) {
                      value.quantity += 1;
                    }
                  }
                  return value;
                });
              }

              return option;
            } else {
              const value = {
                restaurantItemOptionValueId: optionValue.id,
                quantity: 1,
                amountEffectType: optionValue.amountEffectType,
                amount: optionValue.amount,
                name: optionValue.name,
                quantityAble: optionValue.quantityAble,
                id: optionValue.id
              };
              option.values.push(value);
            }
          }
        }
      });
    } else {
      let option = {
        restaurantItemOptionId: defaultOption.id,
        values: [
          {
            restaurantItemOptionValueId: optionValue.id,
            quantity: 1,
            amountEffectType: optionValue.amountEffectType,
            amount: optionValue.amount,
            name: optionValue.name,
            id: optionValue.id,
            quantityAble: optionValue.quantityAble
          }
        ]
      };
      selectedOptions.push(option);
    }
    this.setState({
      selectedOptions
    });
    this.calculateItemsAmount(selectedOptions);
  };
  renderOptionSections = () => {
    const { item } = this.props;
    const { selectedOptionId, selectedOptions } = this.state;
    return (
      <ul>
        {(item.options.length &&
          item.options.map(itemOption => {
            const matched = selectedOptionId === itemOption.id;
            const selectedOption = selectedOptions.find(
              option => option.restaurantItemOptionId === itemOption.id
            );
            return (
              <li key={itemOption.id}>
                <button
                  onClick={e => this.handleAccordionMenu(e, itemOption.id)}
                  className="accordion-button"
                >
                  <p>
                    {itemOption.name}{" "}
                    <label className="small-label">
                      ({this.titleDescription(selectedOption)})
                    </label>
                  </p>
                  <icon
                    className={
                      "icon icon-arrow-3 " + ((matched && "open") || "")
                    }
                  />
                </button>
                <div
                  className={
                    "add-item-page accordion-panel" +
                    ((matched && "-active") || "")
                  }
                >
                  <div className="add-item-options">
                    <ul>
                      {itemOption.values.map(itemValue => {
                        const value =
                          selectedOption &&
                          selectedOption.values &&
                          selectedOption.values.find(
                            selectedValue =>
                              selectedValue.restaurantItemOptionValueId ===
                              itemValue.id
                          );
                        const multipleSelection = itemOption.multipleSelection;
                        const quantity = value && value.quantity;
                        const singleQuantityAble =
                          value && value.quantityAble === 1;
                        const className = (quantity && "active") || "";
                        return (
                          <li key={itemValue.id} className={className}>
                            <a
                              value={itemValue.id}
                              className="cursor-pointer"
                              onClick={e =>
                                this.handleAddValue(e, itemOption.id, itemValue)
                              }
                            >
                              {(quantity && (
                                <icon className="icon icon-okay-2" />
                              )) ||
                                (quantity && <p>{quantity}x</p>) || (
                                  <noscript />
                                )}
                              {className && (
                                <icon className="icon icon-okay-2" />
                              )}
                              <p>{itemValue.name}</p>
                            </a>
                            <div className="d-flex align-items-center">
                              {(itemValue.amount && (
                                <span>
                                  + £{parseFloat(itemValue.amount).toFixed(2)}
                                </span>
                              )) || <noscript />}
                              <div>
                                {(((!multipleSelection && quantity) ||
                                  (!singleQuantityAble && quantity)) && (
                                  <icon
                                    onClick={e =>
                                      this.handleRemoveValue(
                                        e,
                                        itemOption.id,
                                        itemValue
                                      )
                                    }
                                    className="icon icon-trash"
                                  />
                                )) || <noscript />}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </li>
            );
          })) || <noscript />}
      </ul>
    );
  };
  handleItemCount = (event, type) => {
    event.preventDefault();
    const { quantity, selectedOptions } = this.state;
    if (type === "dec") {
      this.setState({ quantity: quantity - 1 }, () => {
        this.calculateItemsAmount(selectedOptions);
      });
    } else {
      this.setState({ quantity: quantity + 1 }, () => {
        this.calculateItemsAmount(selectedOptions);
      });
    }
  };
  handleSaveNewItem = (event, updateBasket) => {
    event.preventDefault();
    const { selectedOptions, quantity } = this.state;
    const { selectedItem, onSubmitItem } = this.props;
    let options = [];
    for (let key in selectedOptions) {
      let obj = {};
      obj["restaurant_item_option_id"] =
        selectedOptions[key].restaurantItemOptionId;
      obj["restaurant_item_option_values"] =
        selectedOptions[key].values.map(value => {
          let updatedObj = {};
          updatedObj.id = value.restaurantItemOptionValueId;
          updatedObj.quantity = value.quantity;
          updatedObj.name = value.name;
          updatedObj.restaurantItemOptionValueId =
            value.restaurantItemOptionValueId;
          updatedObj.quantityAble = value.quantityAble;
          updatedObj.amount = value.amount;
          return updatedObj;
        }) || [];
      options.push(obj);
    }
    const basketItemId = selectedItem.id;
    const note = selectedItem.note || "";
    Api.post(
      "/api/product/checkout/update",
      { basketItemId, options, quantity, note },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else {
          if (response.status) {
            updateBasket(response.basket, true);
            onSubmitItem(event);
          } else {
            console.log(response, "else");
          }
        }
      }
    );
  };
  render() {
    const { selectedItem, onClickBack, onSubmitItem, loading } = this.props;
    const { totalAmount } = this.state;
    return (
      <div>
        <div className="modal-bg" />
        <div className="modal">
          {(selectedItem && (
            <React.Fragment>
              {/* Header */}
              <div className="head-general with-back">
                <a onClick={onClickBack} className="back cursor-pointer">
                  <img src="/png/chevron-left.png" />
                </a>
                <h4>{selectedItem.name}</h4>
                <a onClick={onSubmitItem} className="close cursor-pointer">
                  <i className="icon icon-close" />
                </a>
              </div>
              {/* Header */}
              {(loading && <SubmitItemLoading />) || <noscript />}
              <div className="modal-body no-scroll">
                <div className="update-item-page">
                  <div className="add-item-scroll">
                    {this.renderItemQuantitySection()}
                    <div className="update-item-options white-bg">
                      {this.renderOptionSections()}
                    </div>
                  </div>
                  <GlobalConsumer>
                    {({ updateBasket }) => (
                      <div className="fixed-btn checkout-btn">
                        <button
                          onClick={e => this.handleSaveNewItem(e, updateBasket)}
                        >
                          <span>
                            Save (£{parseFloat(totalAmount).toFixed(2)})
                          </span>
                        </button>
                      </div>
                    )}
                  </GlobalConsumer>
                </div>
              </div>
            </React.Fragment>
          )) || (
            <div className="modal-body">
              selected product is not in your basket !
            </div>
          )}
        </div>
      </div>
    );
  }
}
